import { useState } from 'react';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "What if I'm not sure if I need copywriting?",
      answer: "If you're wondering, you probably do. 90% of businesses fail because they can't communicate their value."
    },
    {
      question: "How long until I see results?",
      answer: "2-3 weeks for traction, 1-2 months for 30% growth if you implement the copy."
    },
    {
      question: "Can I try you without committing to a retainer?",
      answer: "Yes. Start with a project package. Most clients ask to stay on retainer after."
    },
    {
      question: "What if I want confidentiality?",
      answer: "We offer full confidentiality. Add $250 to project packages or $500/mo to retainers."
    },
    {
      question: "Do you work with my industry?",
      answer: "We work with any business that's serious about growth. Real products, real services, real results."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-20 px-6 bg-[#a4ae9e]/5">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#34444b] mb-6">
            Questions? We've Got Answers.
          </h2>
          <p className="text-xl text-[#73807c] max-w-2xl mx-auto">
            The straight talk you need before we work together.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-semibold text-[#34444b] pr-4">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-[#708474] text-xl transition-transform duration-200 ${
                      openFAQ === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-6">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-[#73807c] leading-relaxed text-lg">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#73807c] mb-6">
            Still have questions? Let's talk.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('final-cta');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-[#708474] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#73807c] transition-colors cursor-pointer whitespace-nowrap"
          >
            Book Your Strategy Call
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;